import React, {useMemo} from "react";
import {DashboardWFData} from "@commons/services/presenze_api/dashboard.api";

export const OptionsElencoLavoratori: React.FC<{ data: DashboardWFData | undefined }> = ({data}) => {
    const arrayUniqueByKey = useMemo(() => {
            if (data) {
                const unique = [];
                const distinct = [];
                for (let i = 0; i < data.data.length; i++) {
                    if (!unique[data.data[i].idAziendaMaster]) {
                        distinct.push({idAziendaMaster: data.data[i].idAziendaMaster, denominazione: data.data[i].denominazione});
                        unique[data.data[i].idAziendaMaster] = 1;
                    }
                }
                return distinct;
            }
            return [];
        }
        , [data]);

    return (<>
            <option value={0} className="text-gray-900 relative cursor-default select-none py-2 pl-3 pr-9">
                Il mio team
            </option>
            {arrayUniqueByKey && arrayUniqueByKey.map((item, index) => (
                <option key={index} value={item.idAziendaMaster} className="text-gray-900 relative cursor-default select-none py-2 pl-3 pr-9">
                    {item.denominazione}
                </option>))}
        </>
    )
};
